if (!customElements.get("m-banner-with-slide")) {
  class MBannerWithSlide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.lastActive = null;
      this.initSlider();
    }

    initSlider() {
      const __this = this;
      this.slider = new MinimogLibs.Swiper(`.m-slider-${this.dataset.id}`, {
        autoplay:
          this.dataset.autoplay === "true" ? { delay: this.dataset.timeout, disableOnInteraction: true } : false,
        slidesPerView: 1,
        loop: false,
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        },
        on: {
          init: function (swiper) {
            if (__this.lastActive !== null) {
              __this.slideToIndex(__this.lastActive);
            }
            __this.handleChange(swiper);
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    slideToIndex(index) {
      if (!this.slider || index === null || index === undefined || Number.isNaN(index)) return;

      if (this.slider.params.loop && typeof this.slider.slideToLoop === "function") {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }

    handleChange(swiper) {
      const currentSlide = swiper.slides[swiper.activeIndex];
      if (currentSlide) {
        const currentColor = window.getComputedStyle(currentSlide).getPropertyValue("color");
        currentColor && this.style.setProperty("--swiper-controls-color", currentColor);
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      this.slideToIndex(index);
    }
  }

  customElements.define("m-banner-with-slide", MBannerWithSlide);
}
